import { gql } from "@apollo/client";
import moment from "moment";

export const GET_RECLAMOS_WITHOUT_FILTERS = gql`
query allReclamosWithoutFilters(
    $skip: Int
    $take: Int
    $where: GestionReclamosFilterInput 
    $order: [GestionReclamosSortInput!]
) {
    allReclamosWithoutFilters(skip: $skip, take: $take, where: $where, order: $order)
    {
        items {
            idGestionReclamo
            idEtapaReclamo
            idEstadoReclamo
            numeroReclamo
            idDelegacion
            idAreaReclamo
            fechaRegistro
            idClasificacionReclamo
            idUsuarioResponsable
            idPaciente
            idPacienteNavigation{
                nombre
                apellido
            }
            idCliente
            idEstadoReclamoNavigation{
                descripcion
            }
            idEtapaReclamoNavigation{
                descripcion
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;

export const adaptReclamo = (reclamo) => {
  return {
    idGestionReclamo: reclamo?.idGestionReclamo,
    id: reclamo?.numeroReclamo,
    idDelegacion: reclamo?.idDelegacion,
    idEstadoReclamo: reclamo?.idEstadoReclamo,
    idAreaReclamo: reclamo?.idAreaReclamo,
    fechaRegistro: moment(reclamo?.fechaRegistro).format('DD/MM/YYYY'),
    idClasificacionReclamo: reclamo?.idClasificacionReclamo,
    paciente: reclamo?.idPacienteNavigation ? `${reclamo?.idPacienteNavigation?.nombre} ${reclamo?.idPacienteNavigation?.apellido}` : '-',
    financiador: reclamo?.idCliente,
    estado: reclamo?.idEstadoReclamoNavigation?.descripcion,
    idEtapaReclamo: reclamo?.idEtapaReclamo,
    etapa: reclamo?.idEtapaReclamoNavigation?.descripcion
  };
};

const adaptReclamosArray = (reclamosData) => {
  return structuredClone(reclamosData?.allReclamosWithoutFilters?.items)?.
  map((reclamo) => adaptReclamo(reclamo)) || [];
};

export default adaptReclamosArray;

export const adaptReclamosParsedArray = (reclamosData) => {
  return structuredClone(reclamosData)?.
  map((reclamo) => adaptReclamo(reclamo)) || [];
};